import { useEffect } from "react";
import { Dialog } from "./ui";

export const isMac = () => /Mac|iPhone|iPad/.test(navigator.platform);
/** ⌘ 또는 Ctrl */
export const mod = () => (isMac() ? "⌘" : "Ctrl+");

const groups = (): [string, [string, string][]][] => [
  [
    "어디서나",
    [
      [`${mod()}K`, "채널·사람·위키·할일로 가기, 동작 실행"],
      ["Q", "할일 추가"],
      ["?", "단축키 보기"],
      ["Esc", "창·메뉴·할일 상세 닫기"],
    ],
  ],
  [
    "메시지",
    [
      ["Enter", "보내기"],
      ["Shift+Enter", "줄바꿈"],
      ["Alt+Enter", "알림 없이 보내기"],
      ["@", "사람 멘션"],
      ["오른쪽 클릭", "메시지 메뉴 (휴대폰은 길게 누르기)"],
    ],
  ],
  [
    "위키",
    [
      ["/", "제목·체크리스트·표·템플릿 넣기"],
      ["[[", "다른 페이지 링크"],
      [`${mod()}Enter`, "체크리스트 줄을 할일로"],
      ["↑ ↓ ← →", "페이지 목록에서 옮겨 다니기·펼치기"],
    ],
  ],
  [
    "보드",
    [
      ["Space", "카드 집기·놓기 (집은 뒤 화살표로 옮기기)"],
      ["Enter", "할일 상세 열기"],
    ],
  ],
];

export function ShortcutsDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  if (!open) return null;
  return (
    <Dialog open onClose={onClose} label="단축키" className="shortcuts">
      <div className="dialog-body">
        <h2>단축키</h2>
        <div className="shortcut-groups">
          {groups().map(([title, rows]) => (
            <section key={title}>
              <h3>{title}</h3>
              <dl>
                {rows.map(([key, what]) => (
                  <div key={key} className="shortcut-row">
                    <dt>
                      <kbd>{key}</kbd>
                    </dt>
                    <dd>{what}</dd>
                  </div>
                ))}
              </dl>
            </section>
          ))}
        </div>
        <div className="buttons">
          <button type="button" className="btn" onClick={onClose} autoFocus>
            닫기
          </button>
        </div>
      </div>
    </Dialog>
  );
}

/** 입력 중이 아닐 때 누른 글자 단축키 (Q, ?) */
export function useKeyShortcut(match: (e: KeyboardEvent) => boolean, run: () => void) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.metaKey || e.ctrlKey || e.altKey || e.isComposing || !match(e)) return;
      const t = e.target as HTMLElement;
      if (t.closest("input, textarea, select, [contenteditable=true], dialog")) return;
      e.preventDefault();
      run();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [match, run]);
}
